import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";

const getSalesAccIDCS = async (OrderID: number): Promise<number> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<number>(
        `/SalesOrder/GetSalesAccIDFromOrderID/${encodeURIComponent(OrderID)}`,
    );
    return response.data;
};

export const useGetSalesAccIDCS = (OrderID: number | undefined) =>
    useQuery<number>({
        queryKey: [
            "GetSalesAccIDCS",
            {
                OrderID: OrderID ?? null,
            },
        ],
        queryFn: () => {
            if (!OrderID) {
                throw new Error("Invalid params for GetSalesAccIDCS");
            }
            return getSalesAccIDCS(OrderID);
        },
        enabled: OrderID !== undefined,
        refetchOnWindowFocus: false,
        retry: false,
    });
